import React from 'react'
import { Link } from 'gatsby'
import { BaseBanner } from '../base/BaseBanner'
import { IS_BASE_BANNER_LIKES_OPEN_STORAGE_KEY, useLocalStorage } from '../../Utils/useLocalStorage'

export const LikesBanner = () => {
  const [isVisible, setIsVisible] = useLocalStorage<boolean>(IS_BASE_BANNER_LIKES_OPEN_STORAGE_KEY, true)

  return (
    <BaseBanner
      id="likes-banner"
      isVisible={isVisible}
      onClose={() => setIsVisible(false)}
    >
      <p>
        <Link
          to='/cabinets'
          aria-label='Liker les cabinets'
          title='Liker les cabinets'
          className='cursor-pointer'
        >
          <span className='hidden md:inline'>
            <strong className="font-semibold">Vous pouvez désormais liker vos cabinets préférés !</strong>
            <svg viewBox="0 0 2 2" aria-hidden="true" className="mx-2 inline size-0.5 fill-current">
              <circle r={1} cx={1} cy={1} />
            </svg>
            <span>Rendez-vous sur la page des cabinets</span>
          </span>
          <span className='md:hidden'>
            Vous pouvez désormais liker vos cabinets préférés&nbsp;<strong className="font-semibold">ici</strong>&nbsp;!
          </span>
        </Link>
      </p>
    </BaseBanner>
  )
} 
